const IconForbidden = ({ fillColor = "inherit", size = "24px" }) => {
    return (
        <svg height={size} width={size} viewBox="-144 -144 288 288">
            <path d="m-143 0a143 143 0 1 1 286 0 143 143 0 0 1 -286 0m158 112a113 113 0 0 0 0 -224zm-30-224a113 113 0 0 0 0 224z" transform="rotate(45)" fill={fillColor} />
        </svg>
    );
};

export default IconForbidden;
